import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  threatDetailsFormControl: {
    width: '100%'
  },
  threatDetailsFormElement: {
    width: '100%'
  }
}));

export default useStyles;
